export const UserRole = {
  PROFESSOR: 6,
  TIME_CONTEUDO_XPERIENCE: 7,
  ADMINISTRADOR_CLIENTE: 2,
  ADMINISTRADOR_MASTER: 1,
  ADMINISTRADOR_CONTRATANTE: 3,
  CRIADOR_DE_CONTEUDO_EXTERNO: 7,
};
